<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="profile-post">
                <div class="post-header" id="last-post-tour">
                    <div class="d-flex"><img class="img-thumbnail rounded-circle me-3" src="@/assets/images/user/7.jpg"
                            alt="Generic placeholder image">
                        <div class="flex-grow-1 align-self-center"><router-link to="/app/social-app">
                                <h5 class="user-name">Emay Walter</h5>
                            </router-link>
                            <h6>2 Hours ago</h6>
                        </div>
                    </div>
                    <div class="post-setting"><i class="fa fa-ellipsis-h"></i></div>
                </div>
                <div class="post-body">
                    <div class="img-container">
                        <div class="my-gallery tour-image" itemscope="">
                            <div v-for="(src, index) in imgs" :key="index"  @click="() => showImg(index)" >
                                <img :src="src" class="img-fluid rounded">
                                </div>
                                <vue-easy-lightbox :index="index" :visible="visible" :imgs="imgs" @hide="handleHide" ></vue-easy-lightbox>
                        </div>
                    </div>
                    <div class="post-react mt-4">
                        <ul>
                            <li><img class="rounded-circle" src="@/assets/images/user/3.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/5.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/1.jpg" alt=""></li>
                        </ul>
                        <h6>+20 people react this post</h6>
                    </div>
                    <p>Comfort is very important to me. I think people live better in big houses and in big clothes. Design
                        and style should work toward making you look good and feel good without a lot of effort so you can
                        get on with the things that matter. My shows are about the complete woman who swallows it all. Its a
                        question of survival. Those fashion designers are just crazy.</p>
                    <ul class="post-comment">
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="heart"></vue-feather>&nbsp;&nbsp;Like<span
                                        class="counter">407</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="message-square"></vue-feather>&nbsp;&nbsp;Comment<span
                                        class="counter">302</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="share"></vue-feather>&nbsp;&nbsp;share<span
                                        class="counter">180</span></a></label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'post3Page',
    data(){
      return{
        visible: false,
      imgs: [
         require('../../../assets/images/user-profile/post4.jpg'),
      ]
      }
    },
    methods: {
      showImg (index) {
        this.index = index
        this.visible = true
      },
      handleHide () {
        this.visible = false
      }
    }
}
</script>